export const steps = ['Welcome', 'OTP', 'Profile', 'Documents', 'Check-In'];

export const pageTitles = ['Welcome', 'OTP Verification', 'Profile', 'Documents', 'Select Room'];

export const initialProfile = {
  id: null,
  uuid: '',
  inmateDetailsId: null,
  inmateDetailsUuid: '',
  name: '',
  mobile: '',
  email: '',
  emergencyContactName: '',
  emergencyContactNumber: '',
  address: '',
  workplaceCollege: '',
  workplaceCollegeLocation: '',
  reference1: '',
  reference1Number: '',
  reference2: '',
  reference2Number: '',
};

export const documentTypes = [
  { key: 'photo', label: 'Photo', documentType: 'PHOTO' },
  { key: 'idProof', label: 'ID Proof', documentType: 'ID_PROOF' },
  { key: 'addressProof', label: 'Address Proof', documentType: 'ADDRESS_PROOF' },
];

// export const roomTypes = ['1 - Private', '2 - Sharing', '3 - Sharing', '4 - Sharing'];

// export const rooms = [
//   { id: 'A001', block: 'Block A', floor: 'Floor 0', beds: 3 },
//   { id: 'A201', block: 'Block A', floor: 'Floor 2', beds: 3 },
//   { id: 'D103', block: 'Block D', floor: 'Floor 1', beds: 2 },
//   { id: 'D104-test', block: 'Block D', floor: 'Floor 1', beds: 2 },
//   { id: 'G103', block: 'Block G', floor: 'Floor 1', beds: 3 },
//   { id: 'G104', block: 'Block G', floor: 'Floor 1', beds: 3 },
// ];

export const CheckInTypes = ["Monthly", "Weekly", "Daily", "Quarterly","Half-Yearly", "Yearly"]